import { Form, Spin, Typography } from "antd/es";
import { connect } from "react-redux";
import {
  HorizontalStack,
  Icon,
  Image,
  KCol,
  KGallery,
  KPagination,
  KRow,
  TextInput,
  VerticalStack,
} from "../../components/web-components";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer,
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { withContext } from "../../shared/hoc/with-context";
import { withForm } from "../../shared/hoc/with-form";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { ProductListCollectionSelectedWebScreen_ScreenBase } from "./productlistcollectionselectedwebscreen-base";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [];

class ProductListCollectionSelectedWebScreen_Screen extends ProductListCollectionSelectedWebScreen_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Spin spinning={this.state.spinnerCount > 0}>
          <Form
            form={this.props.form}
            name="basic"
            component={false}
            initialValues={{
              productlistcollectionselectedwebscreen_810087_value: undefined,
            }}
            onValuesChange={(changedValues, allValues) => {
              this.clearFieldValidation(changedValues);
            }}
          >
            <>
              <div
                key="-1"
                id="productlistcollectionselectedwebscreen_body"
                style={
                  {
                    borderStyle: "solid",
                    borderTopWidth: 0,
                    borderRightWidth: 0,
                    borderBottomWidth: 0,
                    borderLeftWidth: 0,
                    backgroundColor: "rgba(245, 247, 251, 1)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "left",
                    display: "block",
                    overflow: "auto",
                    minHeight:
                      "calc(100vh - 0px - 0px - 0px - 0px - 0px - 0px)",
                    maxHeight:
                      "calc(100vh - 0px - 0px - 0px - 0px - 0px - 0px)",
                    height: "calc(100vh - 0px - 0px - 0px - 0px - 0px - 0px)",
                  } as any
                }
              >
                <KRow
                  key="115390"
                  id="115390"
                  align="top"
                  justify="start"
                  horizontalGutter={0}
                  verticalGutter={0}
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      paddingTop: 0,
                      paddingRight: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      fontFamily: "Poppins",
                      fontWeight: 400,
                      fontSize: "15px",
                      color: "rgba(68, 68, 68, 1)",
                    } as any
                  }
                >
                  <KCol
                    key="327232"
                    id="327232"
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KRow
                      key="372704"
                      id="372704"
                      align="top"
                      justify="start"
                      horizontalGutter={0}
                      verticalGutter={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 12,
                          paddingBottom: 8,
                          paddingLeft: 12,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KCol
                        key="791576"
                        id="791576"
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderTopLeftRadius: 200,
                            borderTopRightRadius: 200,
                            borderBottomRightRadius: 200,
                            borderBottomLeftRadius: 200,
                            borderTopWidth: 1,
                            borderRightWidth: 1,
                            borderBottomWidth: 1,
                            borderLeftWidth: 1,
                            borderColor: "rgba(218, 218, 218, 1)",
                            borderStyle: "solid",
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KRow
                          key="103786"
                          id="103786"
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KCol
                            key="42289"
                            id="42289"
                            xs={20}
                            sm={20}
                            md={20}
                            lg={20}
                            xl={20}
                            xxl={20}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-center",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <Form.Item
                              className="kFormItem"
                              name="productlistcollectionselectedwebscreen_810087_value"
                            >
                              <TextInput
                                key="810087"
                                id="810087"
                                kuikaRef={
                                  this
                                    .productlistcollectionselectedwebscreen_810087_value_kuikaTextInputRef
                                }
                                placeholder={ReactSystemFunctions.translate(
                                  this.ml,
                                  810087,
                                  "placeholder",
                                  this.defaultML
                                )}
                                allowClear={false}
                                bordered={true}
                                disabled={false}
                                type="text"
                                iconColor="rgba(0, 0, 0, 1)"
                                formatter="None"
                                isCharOnly={false}
                                autoComplete={true}
                                inputMode="all"
                                speechToText={false}
                                style={
                                  {
                                    borderColor: "transparent",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    backgroundColor: "transparent",
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "block",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              ></TextInput>
                            </Form.Item>
                          </KCol>
                          <KCol
                            key="994943"
                            id="994943"
                            xs={4}
                            sm={4}
                            md={4}
                            lg={4}
                            xl={4}
                            xxl={4}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-center",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <Icon
                              key="925316"
                              id="925316"
                              onClick={(e?: any) => {
                                if (e && e.stopPropagation) e.stopPropagation();
                                this.ProductListCollectionSelectedWebScreenComponent_925316_onClick();
                              }}
                              showCursorPointer
                              iconName="search"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "inline",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "32px",
                                  color: "rgba(33, 33, 46, 1)",
                                  letterSpacing: "1px",
                                } as any
                              }
                            ></Icon>
                          </KCol>
                        </KRow>
                      </KCol>
                    </KRow>
                    <KRow
                      key="448341"
                      id="448341"
                      align="top"
                      justify="start"
                      horizontalGutter={0}
                      verticalGutter={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KCol
                        key="158674"
                        id="158674"
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KGallery
                          key="791825"
                          id="791825"
                          kuikaRef={
                            this
                              .productlistcollectionselectedwebscreen_791825_value_kuikaGalleryViewRef
                          }
                          nodatafoundmessage={ReactSystemFunctions.translate(
                            this.ml,
                            791825,
                            "nodatafoundmessage",
                            this.defaultML
                          )}
                          dataSource={
                            this.state.B2BListProductCollectionSelected
                          }
                          loading={false}
                          phoneColumnsCount={2}
                          tabletColumnsCount={3}
                          desktopColumnsCount={3}
                          hoverFontColor="black"
                          hoverBgColor="white"
                          horizontalGutter={0}
                          verticalGutter={0}
                          showNoDataFoundImage={false}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KRow
                            key="515292"
                            id="515292"
                            onClick={(e?: any) => {
                              if (e && e.stopPropagation) e.stopPropagation();
                              this.ProductListCollectionSelectedWebScreenComponent_515292_onClick();
                            }}
                            showCursorPointer
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                backgroundColor: "rgba(245, 247, 251, 1)",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "contain",
                                backgroundPosition: "left",
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KCol
                              key="970517"
                              id="970517"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderTopLeftRadius: 12,
                                  borderTopRightRadius: 12,
                                  borderBottomRightRadius: 12,
                                  borderBottomLeftRadius: 12,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(249, 249, 249, 1)",
                                  borderStyle: "solid",
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "center",
                                  textAlign: "-webkit-center",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <VerticalStack
                                key="545921"
                                id="545921"
                                direction="vertical"
                                size={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    textAlign: "-webkit-center",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <VerticalStack
                                  key="423040"
                                  id="423040"
                                  direction="vertical"
                                  size={1}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 4,
                                      paddingLeft: 0,
                                      textAlign: "-webkit-right",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <HorizontalStack
                                    key="384230"
                                    id="384230"
                                    direction="horizontal"
                                    size={1}
                                    overflowX="auto"
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        alignItems: "center",
                                        fontFamily: "Poppins",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <Icon
                                      key="581739"
                                      id="581739"
                                      onClick={(e?: any) => {
                                        if (e && e.stopPropagation)
                                          e.stopPropagation();
                                        this.ProductListCollectionSelectedWebScreenComponent_581739_onClick();
                                      }}
                                      showCursorPointer
                                      visibility={
                                        this.state.isComp581739Visible
                                      }
                                      visibilityCondition={(rowData: object) =>
                                        ReactSystemFunctions.isEqualTo(
                                          rowData.isFavorite,
                                          "0"
                                        )
                                      }
                                      iconName="favorite_border"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "24px",
                                          color: "rgba(155, 155, 155, 1)",
                                          letterSpacing: "1px",
                                        } as any
                                      }
                                    ></Icon>
                                    <Icon
                                      key="791652"
                                      id="791652"
                                      onClick={(e?: any) => {
                                        if (e && e.stopPropagation)
                                          e.stopPropagation();
                                        this.ProductListCollectionSelectedWebScreenComponent_791652_onClick();
                                      }}
                                      showCursorPointer
                                      visibility={
                                        this.state.isComp791652Visible
                                      }
                                      visibilityCondition={(rowData: object) =>
                                        ReactSystemFunctions.isEqualTo(
                                          rowData.isFavorite,
                                          "1"
                                        )
                                      }
                                      iconName="favorite"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "24px",
                                          color: "rgba(225, 60, 57, 1)",
                                          letterSpacing: "1px",
                                        } as any
                                      }
                                    ></Icon>
                                  </HorizontalStack>
                                </VerticalStack>
                                <Form.Item
                                  className="kFormItem"
                                  name="productlistcollectionselectedwebscreen_805779_value"
                                >
                                  <Image
                                    key="805779"
                                    id="805779"
                                    value="[datafield:imager]"
                                    zoomOnClick={false}
                                    imageFit="stretch"
                                    style={
                                      {
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        borderBottomRightRadius: 8,
                                        borderBottomLeftRadius: 8,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        width: "100%",
                                        height: "100%",
                                        alignItems: "center",
                                        textAlign: "-webkit-left",
                                        display: "inline",
                                        fontFamily: "Poppins",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  ></Image>
                                </Form.Item>
                              </VerticalStack>
                            </KCol>
                          </KRow>
                        </KGallery>
                        <KPagination
                          key="818753"
                          id="818753"
                          onChange={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.ProductListCollectionSelectedWebScreenComponent_818753_onChange();
                          }}
                          kuikaRef={
                            this
                              .productlistcollectionselectedwebscreen_818753_value_kuikaPaginationRef
                          }
                          total={
                            this.state.B2BListProductCollectionSelected?.at?.(0)
                              ?.totalRowCount ?? undefined
                          }
                          pageSize={10}
                          defaultCurrent={1}
                          current={1}
                          defaultPageSize={10}
                          disabled={false}
                          hideOnSinglePage={true}
                          showLessItems={false}
                          showQuickJumper={false}
                          showSizeChanger={false}
                          showFirstPageButton={false}
                          showLastPageButton={false}
                          showNumbers={true}
                          showText={false}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              textAlign: "-webkit-right",
                            } as any
                          }
                        ></KPagination>
                      </KCol>
                    </KRow>
                  </KCol>
                </KRow>
              </div>
            </>
          </Form>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible:
      state.importMappedExcelModalReducer.visible,
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) =>
    dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) =>
    dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) =>
    dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) =>
    dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (
    dsId,
    tableName,
    primaryKey,
    columnMapping,
    parameters
  ) =>
    dispatch(
      showImportMappedExcelModal(
        dsId,
        tableName,
        primaryKey,
        columnMapping,
        parameters
      )
    ),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal()),
});
const tmp = withGoogleLogin(
  withContext(
    withScreenInput(
      withForm(
        withHistory(
          connect(
            mapStateToProps,
            mapDispatchToProps
          )(ProductListCollectionSelectedWebScreen_Screen)
        )
      )
    )
  )
);
export { tmp as ProductListCollectionSelectedWebScreen_Screen };
//export default tmp;
//export { tmp as ProductListCollectionSelectedWebScreen_Screen };
